import type { SVGProps } from 'react';

const SvgFullscreenLt = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path d='M8 20H4V16' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M16 4H20V8' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M20 16V20H16' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M4 8V4H8' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
export default SvgFullscreenLt;
